function initServiceInformation(root = document) {
  if (typeof Swiper === 'undefined') return;

  root.querySelectorAll('[data-service-information-slider]').forEach((slider) => {
    if (slider.swiper) return;

    const pagination = slider.querySelector('[data-service-information-pagination]');
    const slideCount = slider.querySelectorAll('.swiper-slide').length;
    const autoplayEnabled =
      slider.dataset.autoplay === 'true' &&
      slideCount > 1 &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const autoplayDelay = Number.parseInt(slider.dataset.autoplayDelay, 10) || 5000;

    const serviceInformationSlider = new Swiper(slider, {
      slidesPerView: 'auto',
      spaceBetween: 0,
      speed: 500,
      autoHeight: true,
      allowTouchMove: slideCount > 1,
      autoplay: autoplayEnabled
        ? {
            delay: autoplayDelay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          }
        : false,
      pagination: pagination
        ? {
            el: pagination,
            clickable: true,
            bulletClass: 'service-information__bullet',
            bulletActiveClass: 'is-active',
            bulletElement: 'button',
            renderBullet(index, className) {
              return `<button type="button" class="${className}" aria-label="Afficher la carte ${index + 1}"></button>`;
            }
          }
        : undefined
    });

    const nextButtons = slider.querySelectorAll('[data-service-information-next]');
    const updateNextButtonTabIndexes = () => {
      nextButtons.forEach((button, index) => {
        button.tabIndex = index === serviceInformationSlider.activeIndex ? 0 : -1;
      });
    };

    nextButtons.forEach((button) => {
      button.addEventListener('click', () => {
        if (serviceInformationSlider.isEnd) {
          serviceInformationSlider.slideTo(0);
          return;
        }

        serviceInformationSlider.slideNext();
      });
    });

    updateNextButtonTabIndexes();
    serviceInformationSlider.on('slideChange', updateNextButtonTabIndexes);

    if (autoplayEnabled) {
      slider.addEventListener('focusin', () => serviceInformationSlider.autoplay.stop());
      slider.addEventListener('focusout', (event) => {
        if (!slider.contains(event.relatedTarget)) serviceInformationSlider.autoplay.start();
      });
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initServiceInformation());
} else {
  initServiceInformation();
}

document.addEventListener('shopify:section:load', (event) => initServiceInformation(event.target));
